import { Container, Header, SpaceBetween } from '@cloudscape-design/components'

export default function AssetExplorer() {
  return (
    <SpaceBetween direction="vertical" size="l">
      <Container
        header={
          <Header
            variant="h2"
            description="Manage your factory assets using @smartplant/asset-management component"
          >
            Asset Explorer
          </Header>
        }
      >
        <p>Asset hierarchy will be implemented here using the SmartPlant asset management component.</p>
        <p>This will show Factory → Production Lines → Equipment structure with SiteWise integration.</p>
      </Container>
    </SpaceBetween>
  )
}